import firebase from "firebase/app";
import 'firebase/firestore';

export class Impressaorelatorioanalise {

    
    constructor(dadosParaImpressao, dataini, datafim, qtd) {
      this.dadosParaImpressao = dadosParaImpressao;
      this.datinicio = dataini;//= new Date(dataini.seconds*1000).toLocaleString("pt-BR");
      this.datafim =datafim; //=new Date(datafim.seconds*1000).toLocaleString("pt-BR");
     this.qtd = qtd; //dadosParaImpressao.lenght();
     
      
    }  
  
    async PreparaDocumento() {
        
      const corpoDocumento = this.CriaCorpoDocumento();
      const documento = this.GerarDocumento();
      return documento;
    }

    
  
    CriaCorpoDocumento() {
      
     /* const body = this.dadosParaImpressao.map((prod) => {
        return [
          { text: prod.nome, fontSize: 8 },
          { text: prod.qtdEstoque, fontSize: 8 },
          { text: prod.qtdVendido, fontSize: 8 },
        ];
      });*/

      const body = (() => {
        return [{
            
        }];
      })
  
     
  
      let content = [body];
      
      return content;
    }
    
    
 GerarDocumento() {
        

        
      const documento = {
        pageSize: 'A4',
        //pageMargins: [14, 53, 14, 48],
        pageOrientation: 'portait',
        info: {
            title: 'Relatório Análise',
          },
        content: [
       

            {
                alignment: 'center',
                columns: [
                
    
                        {text:'Relatório de Solicitações em Análise' , style: 'header' },
                            
                           
                        
                ] 
            },
           
            {
               
                columns: [
                
    
                        {text:'Data Inicial:'   },
                        {text:this.datinicio  },
                            
                           
                        
                ] 
            },
            {
               
                columns: [
                
    
                        {text:'Data Final:'   },
                        {text:this.datafim  },
                            
                           
                        
                ] 
            },
           
            {
               
                columns: [
                
    
                        {text:'Nº de Solicitações: '   },
                        {text:this.qtd  },
                            
                           
                        
                ] 
            },
            
            
            '\n\n',
            
                  
                
                               

           this.dadosParaImpressao.map((item)=>{
                       
               return[
                '\n\n',
                {
                    columns: [
                        
                        {text:'Departamento Solicitante:' },
                        {text:item.depsolicitacao},
                        
                        
                ] },
                   
                {
                
                    columns:[
                
                    {text:'Nome Solicitante:' },
                    {text:item.nomesolicitante},
                    {text:'SIAPE:' },
                    {text:item.siapesolicitente },
                    
                    
            ] },

            {
                columns: [
                    
                    {text:'Objetivo:' },
                    {text:item.objetivo},
                    
                    
            ] },
            {
            columns: [
                
                {text:'Data de saída:' },
                {text:item.datahorasaida},
                
                
        ] },
        
    {
        columns: [
                
            {text:'Data de Retorno:' },
            {text:item.datahoraretorno},
            
            
    ]} ,
    {
        columns: [
                
            {text:'Destino:' },
            {text:item.localdestino.description},
            
            
    ] 
        },
        

       
        
                     
            ];
            
            
           }),
            
           '\n\n',
            
        ],
      
          styles: {
            header: {
                fontSize: 13,
                bold: true,
                margin: [0, 0, 0, 10]
            },
            subheader: {
                fontSize: 12,
                bold: true,
                margin: [0, 10, 0, 5]
            },
            tableExample: {
                margin: [0, 5, 0, 15]
            },
            tableHeader: {
                bold: true,
                fontSize: 11,
                color: 'black'
            }
        },
        defaultStyle: {
            // alignment: 'justify'
            fontSize: 11,
        }
  
    };
      return documento;
    }
  }